import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from '../../api-authorization/authorize.service';
import { Ladder } from '../../models/ladder.model';
import { Match } from '../../models/match.model';
import { Pairing } from '../../models/pairing.model';
import { Player } from '../../models/player.model';
import { UserService } from '../../services/user.service';
import { RecordService } from './record.service';
import { DateTime } from 'luxon';
import { RecordMatchBaseComponent } from './record.base.component';

@Component({
  selector: 'record-match',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
})
export class RecordMatchComponent extends RecordMatchBaseComponent implements OnInit {

  public zero_pairing_msg: string = "Congratulations!!  You have played all of your matches(or we haven't started yet)";

  constructor(recordSvc: RecordService,
    userSvc: UserService, http: HttpClient, fb: FormBuilder, router: Router) {
    super(recordSvc, userSvc, http, fb, router);

  }
  public ngOnInit() {
    const p1 = this.userSvc.getUser();
    const p2 = this.recordSvc.ladderInfo();
    const p3 = this.http.get<Pairing[]>('/pairing');

    forkJoin([p1, p2, p3]).subscribe(
      ([resp1, resp2, resp3]) => {
        this.player = new Player(resp1);

        this.ladderInfo = resp2;
        if (DateTime.fromISO(this.ladderInfo.endDate) < DateTime.local()) this.ladderOver = true;

        this.pairings.length = 0;
        for (let p of resp3) {
          this.pairings.push(new Pairing(p));
        }


        /////// the doubles players only wanted 10 out of 14 matches visible
        //if (this.ladderInfo.name.includes("doubles") || this.ladderInfo.name.includes("Doubles")) {
        //  this.pairings = this.pairings.filter((p) => p.round <= 10);
        //}
        this.pairings = this.pairings.sort((a, b) => a.round < b.round ? -1 : 1);


        // fix for iphone/ipad... need to assign first player for the select - null breaks things
        if (this.pairings.length > 0)
          this.matchForm.controls.opponentId.setValue(this.pairings[0].pairingPlayer.id);

        this.busy = false;
      },
      (err) => {

      }
    )
  };
  public saveMatch(evt: any) {
    if (this.busySave) return;
    this.busySave = true;
    let m = new Match(this.matchForm.value);
    this.recordSvc.recordMatch(m).subscribe(
      (resp) => {
        // redirect back to 
        this.router.navigate(['/home']);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public saveRetiredWorker() {
    this.busySave = true;
    const m = new Match({ ...this.matchForm.value, Retired: true });
    this.recordSvc.recordMatch(m).subscribe(
      (resp) => {
        // redirect back to 
        this.router.navigate(['/home']);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public saveForfeitWorker() {

    this.busySave = true;
    const m = new Match({ PairingId: this.matchForm.value.pairingId, Forfeit: true });
    this.recordSvc.recordMatch(m).subscribe(
      (resp) => {
        // redirect back to 
        this.router.navigate(['/home']);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public back(evt: any): void {
    evt.preventDefault();
    this.router.navigate(['/home']);
  }
}
